import { css } from '@emotion/core';
import { rgba, tokens, media } from '@domain-group/fe-brary';
import { typography } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var newListingsTitleIndicator = /*#__PURE__*/css("display:inline-block;width:8px;height:8px;background-color:", colors.interactive.base.default, ";border-radius:50%;");
export var newListingsTitleIndicatorHidden = {
  name: "gyp8mm",
  styles: "visibility:hidden;"
};
export var newListingsTitleText = /*#__PURE__*/css(typography.bodySmallBold, " margin-left:10px;color:", colors.neutral.heavy.default, ";");
export var newListingsTitle = {
  name: "1wounc",
  styles: "display:inline-block;text-transform:uppercase;"
};
export var newListings = /*#__PURE__*/css("display:block;text-decoration:none;border:0;padding:11px;border-bottom:1px solid ", colors.neutral.trim.default, ";", media('>=desktop'), "{border:1px solid ", colors.info.trim.default, ";border-radius:3px;background-color:", colors.neutral.surface.default, ";&:hover{border:1px solid ", colors.info.trim.hover, ";}}&:hover{box-shadow:0 1px 10px 0 ", rgba(colors.neutral.heavy.default, 0.1), ";}");
export var newListingsWithMargin = {
  name: "uewl2b",
  styles: "margin-bottom:20px;"
};
export var newListingsArrowIconContainer = {
  name: "1hgawz4",
  styles: "vertical-align:top;"
};
export var newListingsArrow = {
  name: "1o1uk74",
  styles: "display:inline-block;float:right;margin-top:10px;"
};
export var newListingsArrowText = /*#__PURE__*/css(typography.bodySmall, " margin-right:10px;color:", colors.neutral.heavy.default, ";");
export var newListingsArrowIcon = /*#__PURE__*/css("color:", colors.neutral.medium.default, ";");
export var newListingsSubtitle = /*#__PURE__*/css(typography.bodySmall, " display:block;color:", colors.neutral.base.default, ";padding-left:18px;");
export var districtGroupSection = /*#__PURE__*/css("margin-top:14px;&:not(:first-child){margin-top:32px;", media('>=desktop'), "{display:block;}}");
export var districtGroupItems = /*#__PURE__*/css("margin:auto 10px;", media('>=desktop'), "{margin:auto;}");
export var groupSectionTitle = /*#__PURE__*/css(typography.headingL, " display:none;width:100%;text-align:center;margin-bottom:20px;", media('>=tablet'), " and ", media('<=tablet'), "{margin-top:10px;}", media('>=desktop'), "{width:670px;text-align:left;display:block;margin-top:60px;}");